DialogController = App.loadClass 'core::Angular/DialogController'

class exports.LimeController extends DialogController
    constructor: (@scope, @transitions, @modalInstance, @service) ->
        super(@scope, @transitions, @modalInstance)
        ###
            Get the previous 5 years plus the current year
        ###
        @scope.years = [@service.year...(@service.year - 6)]
        @scope.service = @service

        @previousValues = {
            lime_years_applied: @service.fpcResult.data.lime_years_applied
            lime_years_will_be_applicable: @service.fpcResult.data.lime_years_will_be_applicable
            lime_amount_applied: @service.fpcResult.data.lime_amount_applied
        }

    save: () ->
        @service.save(@service.state.params.id)
        @modalInstance.dismiss('cancel')

    cancel: () ->
        @service.fpcResult.data.lime_years_applied = @previousValues.lime_years_applied
        @service.fpcResult.data.lime_years_will_be_applicable = @previousValues.lime_years_will_be_applicable
        @service.fpcResult.data.lime_amount_applied = @previousValues.lime_amount_applied
        @modalInstance.dismiss('cancel')
